import styled from 'styled-components';

import { screenSizes } from '../../theme/screen';

export const HeroWrapperStyled = styled.div`
  width: 100%;
  margin-bottom: 80px;
`;

export const Container = styled.div`
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin: 0 auto;

  & .hero-title {
    max-width: 690px;
    text-align: center;
    margin: 0 auto;
    line-height: 50px;
    font-weight: 600;
  }

  & .content {
    max-width: 900px;
    text-align: center;
    margin: 0 auto;
    font-size: 16px;
    line-height: 28px;
  }
`;

export const FormSectionWrapperStyled = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  margin-bottom: 70px;
  padding: 20px;
  gap: 80px;
  @media (max-width: 1190px) {
    flex-direction: column;
    padding: 60px;
  }

  @media (max-width: ${screenSizes.md}) {
    flex-direction: column;
  }
`;

export const ReachOut = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;

  gap: 30px;
  & .contact {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 40px;
  }
  & .contact-number {
    display: flex;
    flex-direction: column;
    gap: 16px;
    img {
      width: 25px;
      height: 25px;
    }
  }

  & .social-icons {
    display: flex;
    gap: 5px;
  }
  @media (max-width: ${screenSizes.lg}) {
    & .contact {
      flex-wrap: wrap;
    }
  }
`;
export const ContactForm = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;

  gap: 15px;
  & .msg {
    grid-column: 1 / span 2;
  }
`;

export const LastSection = styled.div`
  background-color: #f3f9fd;
  width: 100%;
  padding: 50px 0px;
  margin: 0 auto;

  & .content {
    display: flex;
    flex-direction: column;
    gap: 25px;
    justify-content: center;
    align-items: center;
  }

  & .content-title {
    font-weight: 600;
    text-align: center;
    line-height: 50px;
    font-size: 32px;
  }
  & .content-desc {
    font-weight: 500;
    text-align: center;
    line-height: 32px;
    font-size: 20px;
  }

  @media (max-width: ${screenSizes.md}) {
    & .content-title {
      font-size: 24px;
      line-height: 32px;
    }

    & .content-desc {
      font-size: 16px;
    }
  }
  @media (max-width: ${screenSizes.sm}) {
    & .content-title {
      font-size: 20px;
      line-height: 32px;
    }
    & .content-desc {
      font-size: 14px;
      line-height: 25px;
    }
  }
`;
